/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Schedule_Cron_LabelInputs */



/**
* | output |
* | --- |
* | "Cron expression" |
*
* @param {Agent_Schedule_Cron_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_schedule_cron_label = /** @type {((inputs?: Agent_Schedule_Cron_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Schedule_Cron_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Cron-Ausdruck")
	return /** @type {LocalizedString} */ ("Cron expression")
});